//------------------------------------------------------------------------------
// BFA10103G 共架申込 機器設備 - 地図/電柱ポップアップ
//------------------------------------------------------------------------------
import React from 'react';
import PropTypes from 'prop-types';
import '@esri/calcite-components/dist/components/calcite-tab';
import '@esri/calcite-components/dist/components/calcite-tabs';
import '@esri/calcite-components/dist/components/calcite-tab-nav';
import '@esri/calcite-components/dist/components/calcite-tab-title';
import '@esri/calcite-components/dist/components/calcite-button';
import {
  CalciteTab,
  CalciteTabs,
  CalciteTabNav,
  CalciteTabTitle,
  CalciteButton,
} from '@esri/calcite-components-react'
import { PoleAttribute, PoleAttributes } from '@/components/map-pole-attr';
import PoleItem from '@/utils/pole-item';
import PopupSetubiList from './pole-setubi';

// 定数
const LOGH = 'BFA10103G pole popup:';

/**
 * 電柱ポップアップタイトル
 */
export function polePopupTitle(attr) {
  const type = attr?.type;
  return (type === 'pole' || type === 'setubi')
      ? PoleItem.longText(attr.pole)
      : PoleItem.longText(attr);
}

/**
 * 電柱ポップアップ内容
 */
export function PolePopupContent({
  attribute,
  setubiMap,
  setubiList,
  onSetubiAdd,
  onSetubiEdit,
  onSetubiDelete,
}) {
  const { type, pole } = parsePoleAttribute(attribute);

  // 設備一覧絞り込み
  const selfList = React.useMemo(() => setubiList.filter((setubi) => (
      pole?.areaCode === setubi.areaCode && 
      pole?.lineCode === setubi.lineCode &&
      pole?.poleNo   === setubi.poleNo
  )), [pole, setubiList]);

  // 選択したタブ
  const [ tabSelected, setTabSelected ] = React.useState(null);
  let tab = tabSelected;

  // タブ表示初期値
  if (tab === null) {
    tab = (type === 'setubi' || selfList.length !== 0)
        ? 'setubi'
        : 'pole';
  }

  // 設備追加ボタン処理
  const handleSetubiAdd = React.useCallback(() => {
    console.info(LOGH, '設備追加', pole.toString());
    onSetubiAdd(pole);
  }, [pole, onSetubiAdd]);

  // 描画
  const poleDisplay = PoleItem.text(pole);
  return (
    <>
      {/* タブ [電柱][設備] */}
      <CalciteTabs scale="s">
        <CalciteTabNav slot="title-group">
          <CalciteTabTitle
            selected={tab === 'pole'}
            onCalciteTabsActivate={() => setTabSelected('pole')}
          >
            電柱
          </CalciteTabTitle>
          <CalciteTabTitle
            selected={tab === 'setubi'}
            onCalciteTabsActivate={() => setTabSelected('setubi')}
          >
            設備
          </CalciteTabTitle>
        </CalciteTabNav>

        {/* [タブ] 電柱属性 */}
        <CalciteTab style={{ height: '7.5rem' }}>
          <PoleAttributes cssStyle={{ marginTop: '8px' }}>
            <PoleAttribute label="地区"     value={pole?.areaName} />
            <PoleAttribute label="冠称"     value={pole?.lineName} />
            <PoleAttribute label="電柱番号" value={poleDisplay} />
            <PoleAttribute label="施設名"   value={pole?.poleKind} />
          </PoleAttributes>
        </CalciteTab>

        {/* [タブ] 設備一覧 */}
        <CalciteTab style={{ height: '7.5rem' }}>
          <PopupSetubiList
            pole={pole}
            setubiList={selfList}
            setubiMap={setubiMap}
            onSetubiEdit={onSetubiEdit}
            onSetubiDelete={onSetubiDelete}
          />
        </CalciteTab>
      </CalciteTabs>

      {/* フッター (右揃え) */}
      <div style={{
        display: 'flex',
        marginTop: '12px',
        flexDirection: 'row',
        justifyContent: 'flex-end',
      }}>
        {/* 設備追加ボタン */}
        <CalciteButton onClick={handleSetubiAdd}>
          設備追加
        </CalciteButton>
      </div>
    </>
  );
}

// プロパティ
PolePopupContent.propTypes = {
  attribute:  PropTypes.object,              // ポップアップ属性
  setubiList: PropTypes.array.isRequired,    // 設備一覧
  setubiMap:  PropTypes.instanceOf(Map),     // 架設設備マップ

  // イベントハンドラー
  onSetubiAdd:    PropTypes.func.isRequired,     // 設備追加
  onSetubiEdit:   PropTypes.func.isRequired,     // 設備編集
  onSetubiDelete: PropTypes.func.isRequired,     // 設備削除
};

// デフォルトエクスポート
export default PolePopupContent;

//
// 電柱グラフィック属性判定
//
function parsePoleAttribute(attr) {
  if (!attr) return { type: null, pole: null };

  // 設備電柱/検索電柱判定
  const type = attr.type;
  if (type === 'setubi' || type === 'pole') {
    return { type, pole: attr.pole };
  }

  // 電柱マスタ判定
  return (attr.areaCode && attr.lineCode && attr.poleNo)
      ? { type: 'master', pole: new PoleItem(attr) }
      : { type: null, pole: null };
}
